import { render, staticRenderFns } from "./ClujiCalendar.vue?vue&type=template&id=3620c587&scoped=true"
import script from "./ClujiCalendar.vue?vue&type=script&lang=js"
export * from "./ClujiCalendar.vue?vue&type=script&lang=js"
import style0 from "./ClujiCalendar.vue?vue&type=style&index=0&id=3620c587&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3620c587",
  null
  
)

export default component.exports